import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const PersonalComputer = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="PersonalComputer" {...props}>
    <path d="M18.9993 2C20.1038 2.00008 20.9993 2.89548 20.9993 4V14.7637L23.1702 19.1055L23.2278 19.2305C23.7745 20.5312 22.8222 21.9996 21.3821 22H2.61743C1.13116 21.9995 0.16473 20.435 0.829346 19.1055L2.99927 14.7656V4C2.99927 2.89573 3.89511 2.00048 4.99927 2H18.9993ZM2.61743 20H8.99927C8.99927 19.448 9.44739 19.0005 9.99927 19H13.9993L14.1018 19.0049C14.6061 19.0561 14.9993 19.4822 14.9993 20H21.3821L19.3821 16H4.61743L2.61743 20ZM4.99927 14H18.9993V4H4.99927V14Z" fill="#000" />
  </StyledIcon>
));

PersonalComputer.displayName = 'PersonalComputer';

export { PersonalComputer };
